import { create } from 'zustand';
import { miniappApi } from '@/api/miniapp/miniappApi';
import { messageOf } from '@/api/miniapp/client';
import type { SmmToolDto } from '@/api/miniapp/types';

/**
 * Инструменты ассистента для вкладки «ИИ».
 *
 * Отдельный список от бэкенда: раньше их приходилось угадывать по названию
 * модуля курса, и набор расходился с тем, что ждёт заказчик. Теперь источник
 * один — `/api/miniapp/smm-tools`.
 */
interface AiToolsState {
  tools: SmmToolDto[];
  loading: boolean;
  error: string | null;
  load(): Promise<void>;
}

export const useAiToolsStore = create<AiToolsState>((set) => ({
  tools: [],
  loading: false,
  error: null,

  async load() {
    set({ loading: true, error: null });
    try {
      set({ tools: await miniappApi.getSmmTools(), loading: false });
    } catch (error) {
      set({
        loading: false,
        error: messageOf(error, 'Не удалось загрузить инструменты'),
      });
    }
  },
}));
